import { useEffect, useState } from "react"
import { useLocation, NavLink } from "react-router-dom"
import PropTypes from "prop-types"
import List from "@mui/material/List"
import Divider from "@mui/material/Divider"
import Link from "@mui/material/Link"
import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import SidenavCollapse from "./SidenavCollapse"
import SidenavRoot from "./SidenavRoot"

import { Collapse } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { useLoading } from "../../LoadingContext"
import { getMenu } from "../../../api/menu"
import { ExtractId } from "../../../util"

import ManageLogo from "pages/manage/logo"
import { HELP_PAGE } from "../../../config"

// Material Dashboard 2 React context
import { useMaterialUIController, setMiniSidenav, setTransparentSidenav, setWhiteSidenav } from "context"

interface Props {
  routes: any[]
  [key: string]: any
}

function Sidenav({ routes, ...rest }: Props) {
  const [controller, dispatch] = useMaterialUIController()
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } = controller
  const location = useLocation()
  const collapseName = location.pathname.replace("/", "")
  const { isLoading, startLoading, stopLoading } = useLoading()
  const [facilityList, setFacilityList] = useState<any[]>([])
  const [dataList, setDataList] = useState<any[]>([])

  const [profileLogo, setProfileLogo] = useState<boolean>(false)

  const [showLogo, setShowLogo] = useState<string>("")
  const [showLifeLog, setShowLifeLog] = useState<boolean>(false)
  const [viewMode, setViewMode] = useState<string>("0")

  let textColor: "white" | "dark" | "inherit" = "white"

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark"
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit"
  }

  const closeSidenav = () => setMiniSidenav(dispatch, true)

  const [isHomeSubmenuOpen, setHomeSubmenuOpen] = useState(false)
  const [isDataRegistrationSubmenuOpen, setIsDataRegistrationSubmenuOpen] = useState(false)

  const toggleHomeSubmenu = () => {
    setHomeSubmenuOpen((prev) => !prev)
  }

  const toggleDataRegistrationSubmenu = (e: React.FormEvent) => {
    e.preventDefault()
    setIsDataRegistrationSubmenuOpen(!isDataRegistrationSubmenuOpen)
    //onMenuSelect('dataRegistration');
  }

  useEffect(() => {
    const fetchMenu = async () => {
      if (localStorage.getItem("session_code") == "") {
        return
      }
      try {
        startLoading()
        const menuData = await getMenu()

        const facility_list = menuData.facility_list
        const auth = localStorage.getItem("account_type")
        setFacilityList(facility_list)
        setDataList(menuData.data_list)
        setShowLogo(menuData.logo)
        //console.log(menuData.facility_list);
        //console.log("表示対象のデータ ↓");
        //console.log(menuData.data_list);
        if (auth == "service") {
          setShowLifeLog(true)
        }
        const view_mode = localStorage.getItem("view_mode")
        setViewMode(view_mode ? view_mode : "0")
      } catch (error: any) {
        if (error.response && error.response.status === 401) {
          //navigate('/'); // セッション切れ時にトップページへリダイレクト
        } else if (!error.response) {
          //ログアウト時にエラーPUが何故か出てしまうので蓋閉じ
          //showConnectionError(true);
        }
      } finally {
        stopLoading()
      }
    }
    fetchMenu()

    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200)
      setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav)
      setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav)
    }

    window.addEventListener("resize", handleMiniSidenav)

    handleMiniSidenav()

    return () => window.removeEventListener("resize", handleMiniSidenav)
  }, [dispatch, location])

  useEffect(() => {
    const fetchMenu = async () => {
      if (localStorage.getItem("session_code") === "") return

      try {
        // 読込完了時飲み処理
        if (isLoading) return
        // 不動産業者アカウントの場合のみ処理
        if (localStorage.getItem("account_type") != "estate") return
        // URLが manage_facility の場合のみ処理
        if (location.pathname !== "/manage_facility") return
        const menuData = await getMenu()
        setFacilityList(menuData.facility_list)
      } catch (error) {
        console.error("Error fetching menu:", error)
      }
    }

    if (!isLoading) {
      fetchMenu()
    }
  }, [isLoading])

  //ロゴ画像編集
  const handleLogo = () => {
    const auth = localStorage.getItem("auth_logo")
    if (auth == "1") {
      setProfileLogo(true)
    }
  }

  const handleLogoClose = (name: string = "") => {
    setProfileLogo(false)
    if (name != "") {
      setShowLogo(name)
    }
  }

  const renderRoutes = routes.map(({ type, name, icon, title, noCollapse, key, href, route }) => {
    let returnValue
    //console.log(collapseName)
    //console.log(key)
    if (type === "help") {
      returnValue = (
        <NavLink key={key} to={route}>
          <SidenavCollapse
            name={name}
            icon={icon}
            onClick={() => {
              window.open(HELP_PAGE)
            }}
            active={key === collapseName}
          />
        </NavLink>
      )
    } else if (type === "collapse") {
      returnValue = href ? (
        <Link href={href} key={key} target="_blank" rel="noreferrer" sx={{ textDecoration: "none" }}>
          <SidenavCollapse name={name} icon={icon} active={key === collapseName} noCollapse={noCollapse} />
        </Link>
      ) : (
        <NavLink key={key} to={route}>
          <SidenavCollapse name={name} icon={icon} active={key === collapseName} />
        </NavLink>
      )
    } else if (type === "log") {
      returnValue = showLifeLog ? (
        href ? (
          <Link href={href} key={key} target="_blank" rel="noreferrer" sx={{ textDecoration: "none" }}>
            <SidenavCollapse name={name} icon={icon} active={key === collapseName} noCollapse={noCollapse} />
          </Link>
        ) : (
          <NavLink key={key} to={route}>
            <SidenavCollapse name={name} icon={icon} active={key === collapseName} />
          </NavLink>
        )
      ) : null
    } else if (type === "manage") {
      returnValue = showLifeLog ? (
        href ? (
          <Link href={href} key={key} target="_blank" rel="noreferrer" sx={{ textDecoration: "none" }}>
            <SidenavCollapse name={name} icon={icon} active={key === collapseName} noCollapse={noCollapse} />
          </Link>
        ) : (
          <NavLink key={key} to={route}>
            <SidenavCollapse name={name} icon={icon} active={key === collapseName} />
          </NavLink>
        )
      ) : null
    } else if (type === "title") {
      returnValue = (
        <MDTypography
          key={key}
          color={textColor}
          display="block"
          variant="caption"
          fontWeight="bold"
          textTransform="uppercase"
          pl={3}
          mt={2}
          mb={1}
          ml={1}
        >
          {title}
        </MDTypography>
      )
    } else if (type === "divider") {
      returnValue = (
        <Divider
          key={key}
          light={
            (!darkMode && !whiteSidenav && !transparentSidenav) || (darkMode && !transparentSidenav && whiteSidenav)
          }
        />
      )
    } else if (type === "home") {
      returnValue = (
        <MDBox>
          <MDBox display="flex" width="100%">
            <NavLink key={key} to={route} style={{ flexGrow: 9 }}>
              <SidenavCollapse name={name} icon={icon} active={key === collapseName} />
            </NavLink>
            <IconButton onClick={toggleHomeSubmenu} size="small" sx={{ flexGrow: 1, color: "#ffffff" }}>
              <ExpandMoreIcon
                sx={{ transform: isHomeSubmenuOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }}
              />
            </IconButton>
          </MDBox>
          {/* サブメニュー（アコーディオン） */}
          <Collapse in={isHomeSubmenuOpen} timeout="auto">
            <MDBox pl={4}>
              {facilityList.map((facility) => (
                <NavLink
                  key={"/facility/" + ExtractId(facility.id)}
                  to={"/facility/" + ExtractId(facility.id)}
                  style={{ flexGrow: 9 }}
                >
                  <SidenavCollapse
                    name={facility.name}
                    icon=""
                    active={
                      "facility/" + ExtractId(facility.id) === collapseName ||
                      collapseName.startsWith("tenant/" + ExtractId(facility.id))
                    }
                  />
                </NavLink>
              ))}
            </MDBox>
          </Collapse>
        </MDBox>
      )
    } else if (type === "data") {
      returnValue = (
        <MDBox>
          {/* メインメニュー */}
          <MDBox display="flex" width="100%">
            <div style={{ flexGrow: 9, pointerEvents: "none" }}>
              <SidenavCollapse name={name} icon={icon} active={key === collapseName} />
            </div>
            <IconButton onClick={toggleDataRegistrationSubmenu} size="small" sx={{ flexGrow: 1, color: "#ffffff" }}>
              <ExpandMoreIcon
                sx={{
                  transform: isDataRegistrationSubmenuOpen ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "0.3s"
                }}
              />
            </IconButton>
          </MDBox>

          {/* サブメニュー（アコーディオン） */}
          <Collapse in={isDataRegistrationSubmenuOpen} timeout="auto">
            <MDBox pl={4} py={1}>
              {dataList.map((data) => {
                const menuItems = {
                  account: { label: "アカウント", key: "manage_account", to: "manage_account" },
                  catv: { label: "サービス提供元", key: "manage_catv", to: "manage_catv" },
                  estate: { label: "不動産業者", key: "manage_estate", to: "manage_estate" },
                  facility: { label: "管理施設", key: "manage_facility", to: "manage_facility" },
                  device: { label: "デバイス", key: "manage_device", to: "manage_device" },
                  estate_mail: { label: "検知メール送信先", key: "manage_estate_mail", to: "manage_estate_mail" },
                  detect_setting: { label: "検知設定", key: "manage_detect_setting", to: "manage_detect_setting" },
                  sensitivity_setting: {
                    label: "感度設定",
                    key: "manage_sensitivity_setting",
                    to: "manage_sensitivity_setting"
                  },
                  data_import: { label: "初期データ登録", key: "data_import", to: "data_import" }
                }

                if (!(data in menuItems)) return null
                if (!showLifeLog || viewMode !== "0") {
                  menuItems.account.label = "ログインアカウント"
                }
                const menuItem = menuItems[data as keyof typeof menuItems]
                return (
                  <>
                    <Collapse in={isDataRegistrationSubmenuOpen} timeout="auto">
                      <NavLink key={"/" + menuItem.key} to={"/" + menuItem.to} style={{ flexGrow: 9 }}>
                        <SidenavCollapse
                          name={menuItem.label}
                          icon=""
                          active={menuItem.key === collapseName}
                          sx={{ height: "50px" }}
                        />
                      </NavLink>
                    </Collapse>
                  </>
                )
              })}
            </MDBox>
          </Collapse>
        </MDBox>
      )
    }

    return returnValue
  })

  return (
    <>
      {profileLogo && <ManageLogo image={showLogo} onClose={handleLogoClose} />}
      <SidenavRoot
        {...rest}
        variant="permanent"
        ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
      >
        <MDBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer", zIndex: "10000", color: "#ffffff" }}
        >
          <Icon fontSize="medium">{miniSidenav ? "menu" : "menu_open"}</Icon>
        </MDBox>
        <MDBox pt={window.innerWidth >= 1200 ? 3 : 5} pb={1} px={4} textAlign="center">
          <MDBox
            display={{ xs: "block", xl: "none" }}
            position="absolute"
            top={0}
            right={0}
            p={1.625}
            onClick={closeSidenav}
            sx={{ cursor: "pointer" }}
          >
            <MDTypography variant="h6" color="secondary">
              <Icon sx={{ fontWeight: "bold" }}>close</Icon>
            </MDTypography>
          </MDBox>
          <MDBox display="flex" alignItems="center">
            {showLogo && showLogo != "" && (
              <>
                {localStorage.getItem("auth_logo") == "1" && showLogo && showLogo != "" && (
                  <MDBox
                    component="img"
                    src={showLogo}
                    alt="Brand"
                    width="100%"
                    onClick={handleLogo}
                    style={{ cursor: "pointer" }}
                  />
                )}
                {!(localStorage.getItem("auth_logo") == "1" && showLogo && showLogo != "") && (
                  <MDBox component="img" src={showLogo} alt="Brand" width="100%" style={{ cursor: "auto" }} />
                )}
              </>
            )}
            {!(showLogo && showLogo != "") && (
              <>
                {localStorage.getItem("auth_logo") == "1" && showLogo && showLogo != "" && (
                  <MDBox width="100%" height="20px" onClick={handleLogo} style={{ cursor: "pointer" }} />
                )}
                {!(localStorage.getItem("auth_logo") == "1" && showLogo && showLogo != "") && (
                  <MDBox width="100%" height="20px" style={{ cursor: "auto" }} />
                )}
              </>
            )}
          </MDBox>
        </MDBox>
        <Divider
          light={
            (!darkMode && !whiteSidenav && !transparentSidenav) || (darkMode && !transparentSidenav && whiteSidenav)
          }
        />
        <List>{renderRoutes}</List>
      </SidenavRoot>
    </>
  )
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: ""
}

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default Sidenav
